<template>
  <modal
    ref="modal"
    :width="400"
    :class="{ saving: loading }"
    body-class="rounded bg-white text-center shadow"
    content-class="bg-transparent shadow-none"
    footer-class="bg-transparent px-0 pb-0 border-0"
    @close-modal="$emit('close')"
  >
    <template #body>
      <div
        v-if="showTextarea"
      >
        <div
          v-html="message"
        />
        <FormTextarea
          v-model="note"
          name="note"
          :label="false"
          class="mb-0"
        />
      </div>
      <div
        v-else
        v-html="message"
      />
    </template>
    <template
      v-if="!loading"
      #footer
    >
      <btn
        :link="false"
        class="flex-fill mr-3 shadow"
        :class="getCancelClass"
        @click="doCancel"
      >
        {{ cancelButtonText }}
      </btn>
      <btn
        :link="false"
        class="flex-fill shadow"
        :class="getConfirmClass"
        @click="doConfirm"
      >
        {{ confirmButtonText }}
      </btn>
    </template>
  </modal>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      required: true,
    },
    confirmClass: {
      type: String,
      default: null,
    },
    cancelClass: {
      type: String,
      default: null,
    },
    confirmButtonText: {
      type: String,
      default: 'Confirm',
    },
    cancelButtonText: {
      type: String,
      default: 'Cancel',
    },
    onCancel: {
      type: Function,
      default: null,
    },
    onConfirm: {
      type: Function,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    showTextarea: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close', 'cancel', 'confirm'],
  data() {
    return {
      note: null,
    }
  },
  computed: {
    getConfirmClass() {
      return this.confirmClass ? this.confirmClass : 'btn-primary'
    },
    getCancelClass() {
      return this.cancelClass ? this.cancelClass : 'btn-light '
    },
  },
  methods: {
    doCancel() {
      if (this.onCancel) {
        this.onCancel()
      } else {
        this.$emit('cancel')
      }
    },
    doConfirm() {
      if (this.onConfirm) {
        this.onConfirm(this.note)
      } else {
        this.$emit('confirm', this.note)
      }
    },
  },
}
</script>
